import { useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/common";
import { AurumOrb } from "@/components/brand/AurumOrb";
import { Sparkles } from "lucide-react";

export default function Coach() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const run = async () => {
    setLoading(true);
    try { const { data } = await api.post("/ai/coach"); setText(data.text); }
    catch { setText("AI TEMPORARILY UNAVAILABLE — please try again."); }
    finally { setLoading(false); }
  };
  return (
    <div className="max-w-3xl mx-auto space-y-5 animate-fade-up">
      <div className="flex items-center gap-3"><Sparkles className="text-aurum" /><h1 className="text-2xl font-bold tracking-tight">AI Performance Coach</h1></div>
      <Card className="p-6">
        <p className="text-sm text-[var(--text-sec)]">Aurum reviews your closed paper trades and highlights patterns in your process — never fabricating statistical significance on small samples.</p>
        <button onClick={run} disabled={loading} data-testid="run-coach" className="mt-4 btn-gold rounded-full px-5 py-2.5 text-sm font-semibold hover:brightness-110 disabled:opacity-50">
          {loading ? "Analyzing your journal…" : "Analyze my performance"}
        </button>
      </Card>
      {loading && <div className="flex justify-center py-8"><AurumOrb status="ANALYZING" size={80} /></div>}
      {text && (
        <Card className="p-6" data-testid="coach-output">
          <div className="text-sm text-[var(--text-sec)] whitespace-pre-wrap leading-relaxed" style={{ borderLeft: "2px solid #D6AE57", paddingLeft: 16 }}>{text}</div>
        </Card>
      )}
    </div>
  );
}
